<template>
<div id="calendar">
    <div class="row area-name area-name-bg">
		<div class="col-sm-12">
        <div class="area_inner_side">
            <div class="area_inner">
                <h4>City Name</h4>
                <p>{{ calendarData ? calendarData.cityName : '--' }}</p>
            </div>
            
            <div class="area_inner">
                <h4>Staff Name</h4>
                <p>{{ calendarData ? calendarData.driverName : '--' }}</p>
            </div>
            <div class="area_inner">
                <h4>Role type</h4>
                <p>{{ calendarData ? calendarData.roleType : '--' }}</p>
            </div>
        </div>
		</div>
    </div>

    <calendar-view :show-date="showDate" :events="events" display-period-uom="month" class="theme-default holiday-us-traditional holiday-us-official">
        <calendar-view-header slot="header" slot-scope="t" :header-props="t.headerProps" @input="setShowDate" />
    </calendar-view>
</div>
</template>

<script>
import {
    helperAndDriverService,
    authService,

} from "../../../services";
import {
    CalendarView,
    CalendarViewHeader
} from "vue-simple-calendar";

export default {
    name: 'dutyTracking',
    data: function () {
        return {
			calendarData:{
                cityName:'',
                driverName:'',
                roleType:'',
            },
            showDate: new Date(),
            events: [
                // {
                // 	id: 'e1',
                // 	startDate: '2023-04-19',
                // 	endDate: '2023-04-19',
                // 	title: `<b>Start Time - 11:07:00 <br> <br> End Time - 03:35:00</b>`,
                // 	style: 'background: #0f6940; color: white;',

                // },
                // {
                // 	startDate: '2023-04-22',
                // 	endDate: '2023-04-22',
                // 	title: `<b>Start Time - 11:07:00 <br> <br> End Time - NA</b>`,
                // 	style: 'background: orange; color: white;',

                // },
                // {		                // 	startDate: '2023-04-01',
                // 	endDate: '2023-04-01',
                // 	title: `<b>Start Time - NA <br> <br> End Time - NA</b>`,
                // 	style: 'background: red; color: white;'
                // },
                // {
                // 	startDate: '2023-04-13',
                // 	endDate: '2023-04-13',
                // 	title: '<b>Start Time - 21:07:00 <br> <br> End Time - 05:35:00</b>',
                // 	style: 'background: #0f6940; color: white;'
                // },
                // {		                // 	startDate: '2023-04-11',
                // 	endDate: '2023-04-11',
                // 	title: `<b>Start Time - 11:07:00 <br> <br> End Time - 03:35:00</b>`,
                // 	style: 'background: #0f6940; color: white;'
                // },
                // {
                // 	startDate: '2023-05-12',
                // 	endDate: '2023-05-12',
                // 	title: '<b>Start Time - 11:07:00 <br> <br> End Time - 03:35:00</b>',
                // 	style: 'background: #0f6940; color: white;'
                // },
                // {		                // 	startDate: '2023-05-19',
                // 	endDate: '2023-05-19',
                // 	title: `<b>Start Time - 11:07:00 <br> <br> End Time - 03:35:00</b>`,
                // 	style: 'background: #0f6940; color: white;'
                // },
                // {
                // 	startDate: '2023-05-22',
                // 	endDate: '2023-05-22',
                // 	title: '<b>Start Time - 11:07:00 <br> <br> End Time - 03:35:00</b>',
                // 	style: 'background: #0f6940; color: white;'
                // }
            ]
        }
    },
    component: {
        "calendar-view": window.CalendarView,
    },
    components: {
        CalendarView,
        CalendarViewHeader,
    },
    methods: {
        setShowDate(d) {
            this.showDate = d;
        },
        getStartTimeAndEndTime() {
            const id = this.$route.params._id;
            let startTimeAndEndTimeList = [];
            return helperAndDriverService
                .dutyTracking(id)
                .then((response) => {
                    this.calendarData.cityName = response.data.cityName; 
                    this.calendarData.driverName = response.data.driverName;
                    this.calendarData.roleType = response.data.role;
                    response.data.response.forEach(e => {
                        e.dutyArray.forEach(element => {
                            var startTimes = element.startTime ? new Date(element.startTime).toLocaleTimeString() : 'NA';
                            var endTimes = element.endTime ? new Date(element.endTime).toLocaleTimeString() : 'NA';
                            let style;
                            if (element.startTime == null) {
                                style = `background: red; color: white;`;
                            } else if (element.endTime == null) {
                                style = `background: orange; color: white;`;
                            } else {
                                style = `background: #0f6940; color: white;`;
                            }
                            startTimeAndEndTimeList.push({
                                startDate: element.startTime,
                                endDate: element.endTime,
                                title: `${startTimes} to ${endTimes}`,
                                style: style,

                            })
                            this.events = startTimeAndEndTimeList;

                            // val['startDate']= element.startTime	;		                            // val['endDate'] = element.endTime;		                            // var startTimes = element.startTime ? new Date(element.startTime).toLocaleTimeString() : 'NA'; 		                            // // var dateTimeStart = startTimes.getHours() + ":" + startTimes.getMinutes() + ":"+ startTimes.getSeconds();
                            // var endTimes = element.endTime ? new Date(element.endTime).toLocaleTimeString() : 'NA'; 
                            // // var dateTimeEnd = endTimes.getHours() + ":" + endTimes.getMinutes() + ":"+ endTimes.getSeconds();		                            // val['title'] = `${startTimes} to ${endTimes}`;

                            // if(element.startTime == null){
                            // 	val['style'] = `background: red; color: white;`;
                            // }else if(element.endTime == null){
                            // 	val['style'] = `background: orange; color: white;`;
                            // }else{
                            // 	val['style'] = `background: #0f6940; color: white;`;
                            // }		                            // this.events.push(val)

                        })

                    })
					this.$store.dispatch("setBreadcrumbTitle",this.calendarData.driverName);

                })
                .catch((error) => {
                    this.$snotify.error("Get Start Time and End Time failed", "Error!");
                });
        },
    },
    mounted() {
        this.getStartTimeAndEndTime();
		this.calendarData = this.$route.params;
       
    },
}
</script>

<style>
#calendar {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    height: 70vh;
    width: 87vw;
    padding-left: 15px;
    padding-top: 20px;
}

.area_inner_side {
    flex: 0 0 95%;
    display: flex;
}

.area_inner h4 {
    font-weight: 600;
    margin-bottom: 5px;
    font-size: 14px;
    color: #0ce595;
    margin-top: 5px;
}

.area_inner p {
    font-size: 15px;
    font-weight: 600;
}
.area_inner {
    background: #0F6940;
    padding: 10px;
    border-radius: 5px;
    margin-right: 15px;
    margin-bottom: 15px;
    color: #fff;
    flex: 1;
    max-width: 20%;
}
</style>



// WEBPACK FOOTER //
// dutyTracking.vue?7807f5e0